import React, { useRef, useState } from 'react';
import {
    Button,
    ClickAwayListener,
    Grow,
    Box,
    Paper,
    Popper,
    MenuItem,
    MenuList,
    Grid
} from '@mui/material';

import Restricted from 'components/library/routing/Restricted';

const MenuGrid = ({ startIcon, label }) => {
    return <Grid container>
        <Grid item xs={startIcon ? 1 : 0}>
            <Box pt={0} pl={1} mr={1}>
                {startIcon}
            </Box>
        </Grid>

        <Grid item xs={startIcon ? 11 : 12}>
            <Box ml={3} mr={1} mt={0.2}>
                {label}
            </Box>
        </Grid>
    </Grid>
}

const CustomMenuItem = (props) => {
    return (
        <Restricted allowFor={props.allowFor}>
            <MenuItem onClick={props.onClick}>
                <MenuGrid {...props} />
            </MenuItem>
        </Restricted>
    )
}

const Menu = ({ buttonLabel, renderButton, menuItems }) => {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const closeWithAction = (action) => {
        action();
        setOpen(false);
    }

    return (
        <>
            {renderButton ?
                renderButton({ ref: anchorRef, onClick: handleToggle }) :
                <Button
                    ref={anchorRef}
                    aria-controls={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={handleToggle}
                    color="primary"
                    variant="outlined"
                >
                    {buttonLabel}
                </Button>
            }

            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    {
                                        menuItems.map(item =>
                                            <CustomMenuItem {...item} key={item.label} onClick={() => closeWithAction(item.action)} />
                                        )
                                    }
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    )
}

export default Menu
